'use client';

import { Suspense, useEffect } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import {
  ADMIN_ON_BEHALF_FLAG,
  clearOnBehalfOfContext,
  getOnBehalfOfContext,
} from '@src/v3/hooks/useOnBehalfOf';
import Loader from '@src/v3/components/loader';

const ADMIN_PATH_PREFIX = '/admin';

/**
 * Ensures on-behalf context does not leak into normal (non-admin) browsing.
 * We only preserve it for explicit admin handoff routes that carry a guard flag.
 */
const OnBehalfRouteGuardContent = () => {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (!pathname) return;

    const isAdminPath = pathname.startsWith(ADMIN_PATH_PREFIX);
    if (isAdminPath) return;

    const isExplicitAdminHandoff =
      searchParams?.get(ADMIN_ON_BEHALF_FLAG) === '1';

    if (!isExplicitAdminHandoff && getOnBehalfOfContext()) {
      clearOnBehalfOfContext();
    }
  }, [pathname, searchParams]);

  return null;
};

const OnBehalfRouteGuard = () => {
  return (
    <Suspense fallback={<Loader isVisible />}>
      <OnBehalfRouteGuardContent />
    </Suspense>
  );
};

export default OnBehalfRouteGuard;
